import { MarketplaceListingTabGroupEnums } from '~/pages/Marketplace/Listings/@types';
import { MarqBrandEnumsListingMonitoringStatusEnum } from '~/swagger/data-contracts';

export const getListingTabGroup = (listingStatus: MarqBrandEnumsListingMonitoringStatusEnum) => {
  switch (listingStatus) {
    case MarqBrandEnumsListingMonitoringStatusEnum.Scanned:
      return MarketplaceListingTabGroupEnums.Scanned;
    case MarqBrandEnumsListingMonitoringStatusEnum.Detection:
      return MarketplaceListingTabGroupEnums.Flagged;
    case MarqBrandEnumsListingMonitoringStatusEnum.Processing:
    case MarqBrandEnumsListingMonitoringStatusEnum.Reporting:
    case MarqBrandEnumsListingMonitoringStatusEnum.SoftNotice:
      return MarketplaceListingTabGroupEnums.InProgress.replace(/-/g, ' ');
    case MarqBrandEnumsListingMonitoringStatusEnum.OnHold:
    case MarqBrandEnumsListingMonitoringStatusEnum.Removed:
    case MarqBrandEnumsListingMonitoringStatusEnum.Denied:
    case MarqBrandEnumsListingMonitoringStatusEnum.NonEnforceable:
    case MarqBrandEnumsListingMonitoringStatusEnum.Dismissed:
      return MarketplaceListingTabGroupEnums.CaseClosed.replace(/-/g, ' ');
    case MarqBrandEnumsListingMonitoringStatusEnum.Archived:
      return MarketplaceListingTabGroupEnums.Archived;
    case MarqBrandEnumsListingMonitoringStatusEnum.TpAll:
      return MarketplaceListingTabGroupEnums.TestPurchase.replace(/-/g, ' ');
    case MarqBrandEnumsListingMonitoringStatusEnum.ReviewNeeded:
      return MarqBrandEnumsListingMonitoringStatusEnum.ReviewNeeded.replace(/_/g, ' ');

    default:
      return MarketplaceListingTabGroupEnums.Flagged;
  }
};
